import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useTranslation } from '@/i18n'

interface RevokeInviteDialogProps {
  isOpen: boolean
  email: string
  onClose: () => void
  onConfirm: () => void
}

const RevokeInviteDialog = ({
  isOpen,
  email,
  onClose,
  onConfirm,
}: RevokeInviteDialogProps) => {
  const { t } = useTranslation()

  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => (!open ? onClose() : null)}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t('common:settings.team.revoke_invite.title')}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t('common:settings.team.revoke_invite.description', { email })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>
            {t('common:settings.team.revoke_invite.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {t('common:settings.team.revoke_invite.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default RevokeInviteDialog
